import { Col, Row } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFDateInput } from "src/components/Shared/NewForms/NFDateInput";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupCompany } from "src/components/Shared/NewForms/NFLookupCompany";
import { NFTextInput } from "src/components/Shared/NewForms/NFTextInput";

export const CashOpeningBalancesDetailMain = () => {
  const { watch } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Document#")} fieldName={"documentNumber"} disabled />
        </Col>
        <Col sm={6}>
          <NFDateInput title={t("DocumentDate")} fieldName={"documentDate"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput fieldName="createdDate" title={t("CreatedDate")} />
        </Col>
        <Col sm={6}>
          <NFTextInput fieldName={"comment"} title={t("Comment")} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFIntInput fieldName={"totalAmount"} title={t("TotalAmount")} />
        </Col>
        <Col sm={6}>
          <NFIntInput fieldName={"totalAmountVat"} title={t("TotalAmountVat")} />
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <NFLookupCompany fieldName={"companyId"} title={t("Company")} />
        </Col>
      </Row>
    </>
  );
};
